import React, { useState } from 'react';
import classNames from 'classnames';
import { isEmpty, map, prop } from 'ramda';
import ElementsBar from '../../layoutItems/ElementsBar';
import SearchBar from '../SearchBar';
import useVariablesSearch from '../../../../../hooks/useVariablesSearch';
import VariableChip from './VariableChip';

const VariablesBlock = ({
  title,
  variables = [],
  searchable = false,
  emptyLabel,
  info
}) => {
  const [isClosed, setIsClosed] = useState(false);
  const { searchTerm, setSearchTerm, filteredVariables } = useVariablesSearch(variables);

  const isBlockEmpty = isEmpty(variables);
  const hasNoResult = !isBlockEmpty && isEmpty(filteredVariables);

  return (
    <ElementsBar
      title={title}
      isClosed={isClosed}
      setIsClosed={setIsClosed}
      info={info}
    >
      <div className={classNames('w-full', { hidden: isClosed })}>
        {searchable && (
          <SearchBar
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            className="my-2"
          />
        )}
        {isBlockEmpty && <p className="text-xs text-flexi-grey">{emptyLabel}</p>}
        {hasNoResult && (
          <p className="text-xs text-flexi-grey">Aucune variable ne correspond à votre recherche.</p>
        )}
        {/* The only scroll container of the column, which is what bounds its height:
            2 blocks x (82px of chrome + 250px of list) + the search bar stays under the
            ~767px the modal actually shows. `overscroll-contain` stops the wheel from
            chaining to .ant-modal-body — and from there to .ant-modal-wrap — once the
            list reaches one of its ends. */}
        <div className="flex flex-col gap-2 max-h-250px overflow-y-auto overscroll-contain scrollbar">
          {map((variable) => (
            <VariableChip
              key={prop('key', variable)}
              name={prop('key', variable)}
              description={prop('description', variable)}
            />
          ), filteredVariables)}
        </div>
      </div>
    </ElementsBar>
  );
};

export default VariablesBlock;
